<div class="modal-container page-content property">
  <div class="modal-header d-flex justify-content-between border-bottom">
    <h5 class="modal-heading">Change Password</h5>
    <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
  </div>
  <div class="modal-body">
    <div class="form-section visible mt-0 p-0 mb-3 border-0">
      <label data-test="current-password-label" class="form-label mt-4">Current Password </label>
      <app-input [formGrp]="form" formCtrlName="password" password [label]="'Current password'"></app-input>

      <label data-test="new-password-label" class="form-label mt-4">New Password </label>
      <app-input [formGrp]="form" formCtrlName="new_password" password [label]="'New password'"></app-input>

      <label data-test="confirm-password-label" class="form-label mt-4">Confirm New Password </label>
      <app-input [formGrp]="form" formCtrlName="confirm_password" password [label]="'Confirm New Password'"></app-input>
      <div *ngIf="getCtrl('confirm_password').touched&&(getCtrl('confirm_password').valid)">
        <p *ngIf="!pwdMatch" class="text-danger">Password does not match</p>
      </div>
    </div>

    <app-button dataTest="save-and-close-btn" (onclick)="save()" [disabled]="!(form.valid&&pwdMatch) || loading" primary>
      {{loading ? 'Saving...': 'Save & Close'}}
    </app-button>
  </div>
</div>
